window.SWATCH_CDN_BASE = 'https://cdn.shopify.com/s/files/1/0794/6669/2844/files/';

window.SWATCH_IMAGE_MAP = {
      "Chili Red": "Strawberry_Jellie_c293e516-a389-4365-89d8-715000f17492.png?v=1771610000",
      "Sunburst Orange": "Orange_Jellie_a977e0e9-e728-4628-a1f5-40b5b15b5b7d.png?v=1771610000",
      "Lemonade Yellow": "Lemon_Jellie_681c9e4b-e89a-4637-8001-c80a4bfd2f00.png?v=1771610001",
      "Holly Green": "Lime_Jellie.png?v=1770839056",
      "Royal Blue": "Blueberry_Jellie.png?v=1770839056",
      "Fuchsia Pink": "Watermelon_jellie.png?v=1770839056",
      "Very Peri Purple": "Grape_Jellie.png?v=1771610000",

      "Chili Red w/ white": "Strawberry_Jellie_2.png?v=1771610000",
      "Sunburst Orange w/ white": "Orange_cream_Jellie_8c8c1559-101f-40cb-88d7-32df20659ccd.png?v=1771610000",
      "Lemonade Yellow w/ white": "Lemon_cream_Jellie_61c33c8b-41bd-42ec-8fae-9d2624d4a6bb.png?v=1791999203",
      "Holly Green w/ white": "Lime_cream_Jellie_ba8cd14f-4805-4e59-9065-ea4c6b4c7b41.png?v=1771610000",
      "Royal Blue w/ white": "Blueberry_Cream_Jellie_5d17f608-f580-4e59-b8d0-981b3ca386c9.png?v=1771610000",
      "Fuchsia Pink w/ white": "watermelon_cream_Jellie_084477c1-527b-4a4e-86e3-9c6c5f5b1864.png?v=1771610000",
      "Very Peri Purple w/ white": "Blueberry_Cream_Jellie_2.png?v=1771536384",
     
      "Chili Red w/ blue": "Strawberry_Burst_Jellie_7ac52e97-7da0-42ce-910a-d507c4f4bc14.png?v=1771610000",
      "Sunburst Orange w/ blue": "Orange_Burst_Jellie_e9f7b676-6cb8-4cb6-8c3c-63a969f0b8b7.png?v=1771610000",
      "Lemonade Yellow w/ blue": "Lemon_Burst_Jellie_2cc69c9e-8cc7-49cd-a3ee-6475b3fa2c97.png?v=1771610001",
      "Holly Green w/ blue": "Lime_Burst_Jellie_cc617a44-2d17-445b-abca-09597871c438.png?v=1771610000",
      "Royal Blue w/ red": "Blueberry_Swirl_Jellie_d7054e69-757c-4d4d-a3af-bf7de71b4998.png?v=1771610000",
      "Fuchsia Pink w/ purple": "Watermelon_Crush_Jellie_887822df-7829-4108-8103-416920a4f012.png?v=1771610000",
      "Very Peri Purple w/ orange": "Grape_Pop_Jellie_2_430x.png?v=1775593114#",

      "Chili Red w/ yellow": "Strawberry_Zest_Jellie_c17fd263-39bd-4593-8ce9-9fa83373ecb7.png?v=1771610000",
      "Sunburst Orange w/ pink": "Orange_Sugar_Jellie_517851c0-8063-4b66-b3e3-6fc8a9d734dd.png?v=1771610000",
      "Lemonade Yellow w/ pink": "LemonSugarJellie_2e8ef2e3-c6c0-4c79-9f10-0b646435df03.png?v=1771610000",
      "Holly Green w/ orange": "Lime_Pop_Jellie_e6611434-e616-42da-bc56-f20adfd763b6.png?v=1771610000",
      "Royal Blue w/ orange": "Blueberry_Pop_Jellie_ca995726-872c-4b45-8f61-3887fe65cda8.png?v=1771610000",
      "Fuchsia Pink w/ orange": "Watermelon_Pop_Jellie_94690536-b0a2-461e-a504-4fb8a95ddaac.png?v=1771610000",
      "Very Peri Purple w/ pink": "Grape_Sugar_Jellie_f1eb88c9-6efa-423c-bd47-1627e6fc3165.png?v=1771610000"
};